import React from "react";
import { Link } from "react-router-dom";
import { Container, Marquee, Reveal } from "./ui";
import { navLinks, socialLinks, site } from "../data/site";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-azure-dark text-paper">
      <div className="noise-panel pointer-events-none absolute inset-0 opacity-[0.07]" />

      {/* Call to action */}
      <Container className="relative pt-24 md:pt-32">
        <Reveal>
          <p className="t-eyebrow text-electric-soft">
            <span className="mr-3 inline-block h-px w-8 bg-electric-soft align-middle" />
            {site.availability}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-7 max-w-4xl font-display text-[clamp(2.5rem,6.5vw,5.5rem)] font-semibold leading-[0.95]">
            Let's build something
            <span className="italic text-electric-soft"> worth keeping.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href={`mailto:${site.email}`}
            className="group mt-10 inline-flex items-center gap-4 border-b border-white/25 pb-2 font-mono text-sm uppercase tracking-[0.14em] transition-colors duration-300 hover:border-electric-soft hover:text-electric-soft"
          >
            {site.email}
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              className="transition-transform duration-300 group-hover:translate-x-1"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
        </Reveal>
      </Container>

      <Marquee
        className="mt-20 border-y border-white/10 py-5 text-white/25"
        items={["Systems", "Pipelines", "Interfaces", "Platforms", "Writing"]}
        itemClassName="font-display text-3xl md:text-5xl"
        speed="slow"
      />

      {/* Directory */}
      <Container className="relative grid grid-cols-2 gap-10 py-16 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <p className="t-eyebrow text-white/45">Index</p>
          <ul className="mt-5 space-y-2.5">
            {navLinks.map(({ name, link }) => (
              <li key={link}>
                <Link
                  to={link}
                  className="link-underline text-sm text-white/75 hover:text-electric-soft"
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-2 md:col-span-1">
          <p className="t-eyebrow text-white/45">Elsewhere</p>
          <ul className="mt-5 space-y-2.5">
            {socialLinks.map((s) => (
              <li key={s.name}>
                <a
                  href={s.url}
                  target={s.url.startsWith("http") ? "_blank" : undefined}
                  rel="noreferrer"
                  className="link-underline text-sm text-white/75 hover:text-electric-soft"
                >
                  {s.name}
                  <span className="ml-2 text-white/35">{s.handle}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-2 md:col-span-2">
          <p className="t-eyebrow text-white/45">Studio</p>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
            {site.intro}
          </p>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-white/45">
            {site.role} · GMT
          </p>
        </div>
      </Container>

      <Container className="relative flex flex-col gap-3 border-t border-white/10 py-7 font-mono text-[10px] uppercase tracking-[0.18em] text-white/40 md:flex-row md:items-center md:justify-between">
        <span>
          © {year} {site.name}
        </span>
        <span>Designed &amp; built in Ghana</span>
        <span>All rights reserved</span>
      </Container>
    </footer>
  );
};

export default Footer;
